import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Icon, Tooltip } from "../../../components";
import { history, notification, TabelaVendaService } from "../../../services";
import { responseErros } from "../../../utils";
import { FormFiltroAvancado } from "./components";
import { PermisoesHelper } from "../../../helpers";

const ListTabelaVendaView = () => {
  const tabelaVendaService = new TabelaVendaService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("tabelas-venda-visualizar");
  const [loading, setLoading] = useState(false);
  const [tabelaVendaList, setTabelasVendaList] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  
  const colunas = [
    {
      field: "ativado",
      headerName: "Status",
      flex: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip 
            title={params.value ? "Ativado" : "Desativado"} 
            arrow placement="top">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: params.value ? "#4FBB53" : "#DC3545", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
      }
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
    {
      field: "tipoTabela",
      headerName: "Tipo de tabela",
      flex: 500,
      sortable: false,
      valueGetter: (params) =>
        params.value === "TODOS_PRODUTOS" ? "Todos produtos" : "Por Produto",
    },
  ];

  useEffect(() => {
    buscaTabelasVenda();
  }, []);

  const buscaTabelasVenda = async function (filter) {
    setLoading(true);
    const result = await tabelaVendaService.getAll(filter);
    if (!result.isAxiosError) {
      setTabelasVendaList(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrarTabelaVenda = function () {
    history.push("/estoque/tabelas-venda/create");
  };

  const onClickEditTabelaVenda = function (id) {
    history.push(`/estoque/tabelas-venda/${id}`);
  };

  const onClickDeleteTabelaVenda = async function (id) {
    const data = tabelaVendaList.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${data.descricao}?`
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await tabelaVendaService.deletar(id);
      if (!result.isAxiosError) {
        buscaTabelasVenda();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const buscarPesquisaAvancada = async (filter) => {
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    const result = await tabelaVendaService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    if (!result.isAxiosError) {
      setTabelasVendaList(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscaTabelasVenda(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  return (
    <ListLayout
      title="Tabelas de Venda"
      loading={loading}
      onClickCadastrar={onClickCadastrarTabelaVenda}
      permissaoButton={permissoesHelper.temPermisao("tabelas-venda-cadastrar")}
    >
      <DataGrid
        rows={tabelaVendaList}
        rowCount={rowCount}
        columns={colunas}
        onClickEdit={onClickEditTabelaVenda}
        paginationMode={"server"}
        onClickDelete={onClickDeleteTabelaVenda}
        sendServer={(props) => sendServerDatagrid(props)}
        FormFiltroAvancado={FormFiltroAvancado}
        visualizarShow={permissoesHelper.temPermisao(
          "tabelas-venda-visualizar"
        )}
        editShow={permissoesHelper.temPermisao("tabelas-venda-editar")}
        deleteShow={permissoesHelper.temPermisao("tabelas-venda-excluir")}
      />
    </ListLayout>
  );
};

export default ListTabelaVendaView;
